module.exports = __webpack_public_path__ + "static/media/lynette-sikic-micanovic.c112a907.jpg";